import React from 'react';
import { ChakraProvider, Box } from '@chakra-ui/react';
import Dashboard from './components/Dashboard';
import theme from './theme';

function App() {
  return (
    <ChakraProvider theme={theme}>
      <Box minH="100vh" bg="gray.50" py={8}>
        <Dashboard />
      </Box>
    </ChakraProvider>
  );
}

export default App;
